module.exports = __webpack_public_path__ + "static/media/one.332ac764.ogg";